import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { FormContainer, useForm } from 'react-hook-form-mui';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import { APIContext } from '../../Contexts/APIContext';
import ValidatedTextField from '../../Utilities/Forms/ValidatedTextField';
import CreatEditAdminViewModel from './ViewModels/CreateEditAdminViewModel';

interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
    userId: string | null;
}

export default function CreateEditUser(props: IProps) {
    const { get, post, showMessage, loading } = React.useContext(APIContext);
    const { open, onClose, userId } = props;

    const formContext = useForm<CreatEditAdminViewModel>({
        defaultValues: new CreatEditAdminViewModel(),
    });

    const { reset } = formContext;

    React.useEffect(() => {
        if (userId && userId.length > 0) {
            getData();
        }
    }, [userId]);

    const getData = async () => {
        await get("AdminUser", `GetUserDetails?id=${userId}`, reset);
    }

    const submit = async (form: any) => {
        await post("AdminUser", `CreateEditAdminUser?id=${userId}`, form, checkCloseDialog);
    }

    const checkCloseDialog = async (success: boolean = true) => {
        reset(new CreatEditAdminViewModel());
        if (success) {
            if (userId === null) {
                showMessage('success', 'User has been added');
            }
            else {
                showMessage('success', 'User has been updated');
            }
        }
        onClose(success);
    }

    return (
        <Dialog
            open={open}
            onClose={() => checkCloseDialog(false)}
            maxWidth="sm"
            fullWidth
        >
            <FormContainer
                formContext={formContext}
                onSuccess={submit}
            >
                <DialogTitle>{userId === null ? "Create User" : "Edit User"}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid size={6}>
                            <ValidatedTextField label="First Name" name="firstName" required />
                        </Grid>
                        <Grid size={6}>
                            <ValidatedTextField label="Last Name" name="lastName" required />
                        </Grid>
                        <Grid size={12}>
                            <ValidatedTextField label="Email" name="email" required disabled={userId !== null} />
                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button disabled={loading} variant="contained" type="submit">{userId ? "Edit" : "Add"}</Button>
                        <Button disabled={loading} onClick={() => checkCloseDialog(false)} color="error">Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </FormContainer>
        </Dialog>
    );
}